/* eslint-disable @typescript-eslint/no-explicit-any */
// Tanstack is using any for the built-in filter functions.
import type { FilterFn } from "@tanstack/react-table"

// Utils
function testFalsey(val: any) {
  return val === undefined || val === null || val === ""
}

export const equalsOneOf: FilterFn<any> = (
  row,
  columnId: string,
  filterValue: unknown[],
) => {
  return filterValue.some((filterVal) => row.getValue(columnId) === filterVal)
}

equalsOneOf.autoRemove = (val: any) => testFalsey(val) || !val?.length
